document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'themex-recent-searches';
  const MAX_RECENT = 5;

  const section = document.getElementById('recent-searches-section');
  const list = document.getElementById('recent-searches-list');
  const itemTemplate = document.getElementById('recent-search-item-template');
  const clearButton = document.getElementById('clear-recent-searches');
  const searchInput = document.getElementById('predictive-search-input');

  const getRecentSearches = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  };

  const saveRecentSearch = (query) => {
    const trimmed = query?.trim();
    if (!trimmed || trimmed.length < 1) return;

    let searches = getRecentSearches();

    // Remove exact duplicates (case-insensitive) — distinct related searches
    // (e.g. "shampoo" and "shampoo bar") are kept as separate entries.
    searches = searches.filter((s) => s.toLowerCase() !== trimmed.toLowerCase());

    searches.unshift(trimmed);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches.slice(0, MAX_RECENT)));
  };

  const renderRecentSearches = () => {
    const searches = getRecentSearches();

    if (!section || !list || !itemTemplate) return;

    if (searches.length === 0) {
      section.classList.add('hidden');
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    list.replaceChildren();

    for (const term of searches) {
      const item = itemTemplate.content.cloneNode(true);
      const link = item.querySelector('a');
      const textElement = item.querySelector('[data-recent-search-text]');

      if (link) {
        link.href = `${root}search?q=${encodeURIComponent(term)}`;
        link.dataset.query = term;
      }
      if (textElement) textElement.textContent = term;

      list.appendChild(item);
    }

    section.classList.remove('hidden');
  };

  const trackSearch = (query) => {
    if (!query || query.trim().length < 1) return;
    saveRecentSearch(query.trim());
  };

  list?.addEventListener('click', (e) => {
    const item = e.target.closest('[data-query]');
    if (item && searchInput) {
      e.preventDefault();
      searchInput.value = item.dataset.query;
      searchInput.dispatchEvent(new Event('input'));
    }
  });

  clearButton?.addEventListener('click', () => {
    localStorage.removeItem(STORAGE_KEY);
    if (section) section.classList.add('hidden');
    if (list) list.replaceChildren();
  });

  window.searchRecentSearches = {
    getRecentSearches,
    saveRecentSearch,
    trackSearch,
    renderRecentSearches,
  };
});
